import { GNBHeight, GNBHeightMobile } from '@/containers/Header/GNB.style'
import { Element } from 'react-scroll'
import styled from 'styled-components'

const ScrollSection = styled.div`
	padding-right: 72px;
	width: calc(100% - 340px);
	@media (max-width: 1200px) {
		width: 100%;
		padding-right: 0;
	}
`

const ProductDetailContentWrapper = styled.div`
	display: flex;
	@media (max-width: 1200px) {
		padding: 0 12px;
	}
	@media (max-width: 768px) {
		position: relative;
		padding: 8px 16px;
	}

	.detail-content {
		padding-top: 48px;
		display: flex;
		flex-direction: column;
		@media (max-width: 768px) {
			padding-top: 32px;
		}
	}

	.studio-promotion-image {
		margin-top: 44px;

		&.m {
			display: none;
		}

		@media (max-width: 768px) {
			&.w {
				display: none;
			}

			&.m {
				display: block;
			}
		}
	}
`

const StyledAnchor = styled.ul`
	z-index: 2;
	display: flex;
	position: sticky;
	top: ${GNBHeight}px;
	background-color: ${(props) => props.theme.new.colors.white};
	align-items: center;
	justify-content: space-around;
	cursor: pointer;
	font-weight: 600;
	color: ${(props) => props.theme.new.colors.sol_gray_400};
	border-bottom: 1px solid ${(props) => props.theme.new.colors.sol_gray_100};
	transition: top 0.2s ease-in-out;

	:before,
	:after {
		content: '';
		display: block;
		width: calc(100%);
		position: absolute;
		bottom: -1px;
		border-bottom: 1px solid ${(props) => props.theme.new.colors.sol_gray_100};
		@media (max-width: 1200px) {
			width: 30px;
		}
	}

	:before {
		right: calc(100% + 60px);
		left: 100%;
	}

	:after {
		right: 100%;
	}

	body:has(.headroom--unpinned) & {
		top: 0;
	}

	li {
		flex: 1;
		align-items: center;
		display: flex;
		justify-content: center;

		a {
			padding: 16px 10px;
			width: 100%;
			flex: 1;
			align-items: center;
			display: flex;
			justify-content: center;
			line-height: 1.5;
			color: ${(props) => props.theme.new.colors.sol_gray_400};

			&.active {
				padding: 16px 10px 14px;
				border-bottom: 2px solid ${(props) => props.theme.new.colors.sol_indigo_500};
				color: ${(props) => props.theme.new.colors.sol_indigo_500};
			}
		}
	}

	@media (max-width: 1200px) {
	}
	@media (max-width: 768px) {
		font-size: 14px;
		margin: 0 -16px;
		top: ${GNBHeightMobile}px;
		li a {
			padding: 12px 5px;
			&.active {
				padding: 12px 5px 10px;
			}
		}
	}
`
const AuthorTab = styled(Element)`
	padding: 32px;
	background-color: ${(props) => props.theme.new.colors.sol_gray_0};
	border-radius: 6px;

	p {
		font-size: 14px;
		font-weight: 600;
		color: ${(props) => props.theme.new.colors.sol_indigo_500};
		margin: 0 0 8px;
		line-height: 22px;
	}

	h5 {
		height: 32px;
		display: flex;
		font-size: 24px;
		font-weight: 600;
		align-items: center;
		margin-bottom: 20px;

		.img-wrapper {
			width: 32px;
			height: 32px;
			border-radius: 50%;
			margin-right: 8px;
			display: flex;
			align-items: center;

			img {
				border-radius: 50%;
				height: fit-content;
			}
		}

		a {
			color: ${(props) => props.theme.new.colors.sol_indigo_500};
			font-size: 14px;
			margin-left: 12px;
			display: flex;
			align-items: center;

			i {
				vertical-align: middle;
			}
		}
	}

	> div {
		font-size: 16px;
		color: ${(props) => props.theme.new.colors.sol_gray_500};
		line-height: 27px;
	}

	@media (max-width: 768px) {
		padding: 20px;
		p {
			font-size: 12px;
		}

		h5 {
			font-size: 20px;
			margin-bottom: 16px;
		}

		> div {
			font-size: 14px;
		}
	}
`
const ContentWrapper = styled(Element)`
	&:nth-of-type(1) {
		padding-top: 0;
	}

	border-radius: 6px;
	padding-top: 72px;

	> h3 {
		font-size: 20px;
		margin-bottom: 16px;
		font-weight: 700;
	}

	.wrapper {
		border-radius: 6px;
		background-color: ${(props) => props.theme.new.colors.sol_gray_0};
		padding: 20px;
		color: ${(props) => props.theme.new.colors.sol_gray_600};
		white-space: pre-wrap;
		span {
			line-height: 1.5;
		}

		> :first-child.title {
			margin-bottom: 8px;
		}
		.title {
			font-weight: 700;
		}
	}

	@media (max-width: 768px) {
		> h3 {
			font-size: 16px;
		}
	}
`
const PreviewTab = styled(ContentWrapper)`
	div {
		display: flex;
		flex-direction: column;
		gap: 40px;
	}

	img {
		border-radius: 6px;
		border: 1px solid ${(props) => props.theme.new.colors.sol_gray_100};
	}
`
const DetailTab = styled(ContentWrapper)`
	.description {
		margin-bottom: 16px;
		line-height: 1.5;
	}
	ul {
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
		gap: 16px;

		li {
			width: calc(50% - 20px);
			display: flex;

			span {
				display: inline-block;
				line-height: 1.5;
			}

			span.title {
				width: 100px;
			}

			span.content {
				width: calc(100% - 100px);
				color: ${(props) => props.theme.new.colors.sol_gray_600};
			}
		}
	}

	@media (max-width: 768px) {
		ul {
			flex-direction: column;

			li {
				width: 100%;
			}
		}
	}
`

const BookInfoTab = styled(ContentWrapper)`
	.info-cell {
		display: flex;
		gap: 16px;

		margin-top: 32px;

		@media screen and (max-width: 768px) {
			flex-direction: column;
		}

		.title {
			min-width: 100px;
			font-weight: 600;
		}

		.content {
			color: ${(props) => props.theme.new.colors.sol_gray_600};
			flex-grow: 1;
			line-height: 1.5;
			white-space: break-spaces;
			> p {
				line-height: 1.5;
				color: ${(props) => props.theme.new.colors.sol_gray_600};
			}

			text-align: justify;
		}
	}
`

const RefundTab = styled(ContentWrapper)<{ producttype?: string }>`
	${(props) => props.producttype === 'handout' && 'padding-top: 0;'}
	h3 {
		${(props) => props.producttype === 'handout' && 'font-size:16px ;'}
	}
	.content {
		line-height: 1.5;
		color: ${(props) => props.theme.new.colors.sol_gray_600};
	}

	.wrapper:not(:last-of-type) {
		margin-bottom: 24px;
	}

	ul > li {
		color: ${(props) => props.theme.new.colors.sol_gray_600};
		list-style-type: disc;
		margin-inline-start: 24px;
	}

	ol {
		padding: 0;
		margin-bottom: 0;
	}
	ol > li {
		color: ${(props) => props.theme.new.colors.sol_gray_600};
		list-style-type: decimal;
		margin-inline-start: 24px;
	}
`
const PriceTab = styled.div`
	position: sticky;
	margin-top: 56px;
	top: 131px;

	padding-top: 40px;
`
const ContentsTab = styled(ContentWrapper)`
	span:first-child {
		margin-right: 16px;
	}

	> div {
		margin-top: 20px;
		display: flex;
		flex-direction: column;
		gap: 16px;
	}

	div {
		color: ${(props) => props.theme.new.colors.sol_gray_600};
	}

	@media (max-width: 768px) {
		span {
			font-size: 14px;
		}

		span:first-child {
			margin-right: 12px;
		}
	}
`

export {
	AuthorTab,
	BookInfoTab,
	ContentWrapper,
	ContentsTab,
	DetailTab,
	PreviewTab,
	PriceTab,
	ProductDetailContentWrapper,
	RefundTab,
	ScrollSection,
	StyledAnchor,
}
